import Page from "@/lib/pages/Page";
import {View} from "react-native";
import Nav from "@/lib/components/Nav";
import ActionButton from "@/lib/components/ActionButton";
import {Color} from "@/lib/styles";
import Editable from "@/lib/components/Editable";
import PrimaryText from "@/lib/components/PrimaryText";

export default function Preferences() {
    return (
        <Page>
            <View>
                <Editable color={Color.PrimaryText} onPress={()=>{}}>
                    <PrimaryText>Foo</PrimaryText>
                    <PrimaryText>Bar</PrimaryText>
                </Editable>
            </View>
            <Nav>
                <ActionButton
                    onPress={()=>{}}
                    color={Color.Green}
                    title={"Lagre"}
                    />
            </Nav>
        </Page>
    )
}